import { getTomorrow } from 'utils/util';
import * as XLSX from 'xlsx';
import { USDollar, toTitleCase } from 'utils/format';
import { formatCurrency } from 'utils/format';

function prepareData(payouts, transactionId2Status) {
    var data = [
        [
            'Investment Entity',
            'Investor',
            'Fund',
            'Payment Company',
            'Start Date',
            'End Date',
            'Currency',
            'Frequency',
            'Interest',
            'Invested Amount',
            'Account Balance',
            'Amount',
            'Type',
            'Next Payment Date',
            'Next Payment Due',
            'Status',
        ], // Headers
    ];
    for (const accountId of Object.keys(payouts)) {
        const positions = payouts[accountId];
        for (const position of positions) {
            const investorText = position.investors
                .map((investor) => {
                    if (!investor.legal_name && !investor.email) {
                        return '';
                    } else if (!investor.legal_name) {
                        return investor.email;
                    } else if (!investor.email) {
                        return investor.legal_name;
                    } else {
                        return `${investor.legal_name}\n${investor.email}`;
                    }
                })
                .join('\n');
            var curPositionRow = [];
            curPositionRow.push(position.account_name);
            curPositionRow.push(investorText);
            curPositionRow.push(position.fund_name);
            curPositionRow.push(position.payment_company_name);
            curPositionRow.push(position.funding_receipt_date.slice(0, 10));
            curPositionRow.push(position.actual_redemption_date.slice(0, 10));
            curPositionRow.push(position.currency);
            curPositionRow.push(toTitleCase(position.payout_frequency));
            curPositionRow.push(
                `${
                    position.overall_interest
                        ? Math.max(
                              position.overall_interest,
                              position.annual_interest_rate
                          )
                        : position.annual_interest_rate
                }%`
            );
            curPositionRow.push(
                formatCurrency(position.invested_amount, position.currency)
            );
            curPositionRow.push(
                formatCurrency(position.account_balance, position.currency)
            );
            curPositionRow.push(
                formatCurrency(position.transaction_amount, position.currency)
            );
            curPositionRow.push(toTitleCase(position.transaction_type));
            curPositionRow.push(position.timestamp);
            curPositionRow.push(getTomorrow(position.timestamp));
            curPositionRow.push(
                toTitleCase(transactionId2Status[position.transaction_id])
            );
            data.push(curPositionRow);
        }
    }
    return data;
}

function exportToExcel(data, fileName = 'Investor_Report.xlsx') {
    try {
        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert data to worksheet with minimal formatting
        const worksheet = XLSX.utils.aoa_to_sheet(data, {
            cellDates: true, // Handle dates properly
            raw: false, // Use more basic cell formatting
        });

        // Set very basic column widths
        worksheet['!cols'] = Array(data[0].length).fill({ wch: 20 });

        // Set basic row heights
        worksheet['!rows'] = Array(data.length).fill({});

        // Append worksheet with minimal styling
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Payout Summary');

        // Write file with basic options
        const wopts = {
            bookType: 'xlsx',
            type: 'binary',
            cellStyles: false, // Disable complex styling
            cellDates: true,
            bookSST: false, // Disable shared strings table
        };

        XLSX.writeFile(workbook, fileName, wopts);
    } catch (error) {
        console.error('Error generating Excel file:', error);
    }
}

export function exportPayoutSummary(payouts, transactionId2Status) {
    const data = prepareData(payouts, transactionId2Status);
    exportToExcel(data, 'Payout Summary.xlsx');
}
